import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/', name: 'home', component: () => import('@/views/HomeView.vue') },
  { path: '/categories', name: 'categories', component: () => import('@/views/CategoriesView.vue') },
  { path: '/categories/:id', name: 'category', component: () => import('@/views/CategoriesView.vue') },
  { path: '/products/:id', name: 'product-detail', component: () => import('@/views/ProductDetailView.vue') },
  { path: '/cart', name: 'cart', component: () => import('@/views/CartView.vue'), meta: { hideCartFloat: true } },
  { path: '/checkout', name: 'checkout', component: () => import('@/views/CheckoutView.vue'), meta: { hideCartFloat: true } },
  { path: '/orders', name: 'orders', component: () => import('@/views/OrdersView.vue') },
  { path: '/orders/:id', name: 'order-track', component: () => import('@/views/OrderTrackView.vue') },
  { path: '/orders/:id/rate', name: 'order-rate', component: () => import('@/views/RateOrderView.vue') },
  { path: '/account', name: 'account', component: () => import('@/views/AccountView.vue') },
  { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { bottomNav: false } },
  { path: '/addresses', name: 'addresses', component: () => import('@/views/AddressBookView.vue') },
  { path: '/wallet', name: 'wallet', component: () => import('@/views/WalletView.vue') },
  { path: '/referral', name: 'referral', component: () => import('@/views/ReferralView.vue') },
  { path: '/settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
  { path: '/help', name: 'help', component: () => import('@/views/HelpView.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/' }
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() { return { top: 0 }; }
});
